import React, { Component } from 'react';
// react component for creating dynamic tables
import ReactTable from 'react-table';
import 'react-table/react-table.css';
import { Grid, Row, Col, Navbar, Badge } from 'react-bootstrap';
import WidgetSearchName from './widget-searchName';
import Card from 'components/Card/Card.jsx';
import Button from 'components/CustomButton/CustomButton.jsx';
import moment from 'moment';
import SweetAlert from 'react-bootstrap-sweetalert';
import 'moment/locale/es';

//Redux
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import * as ClientsActions from './redux/ClientsActions';
import Loading from '../../components/Loading';
import auth from '../../lib/auth';
import feathers from '../../feathers';

moment.locale('es');

class ClientsIndex extends Component {
  constructor(props) {
    super(props);
    this.state = {
      formData: {
        searchClient: '',
      },
      data: [],
      totalClients: '',
      disabledExport: false,
      openConfirm: false,
      id: '',
    };
  }

  getClients = async () => {
    await this.props.find({
      $sort: {
        firstName: 1,
      },
      deleted: { $ne: true },
      franchiseId: auth.getCurrentUser().franchiseId,
      $populate: {
        path: 'assignedTo',
        select: '_id email firstName lastName franchiseId phone',
        match: {
          $or: [
            { isDeleted: false },
            { isDeleted: { $exists: false } },
          ],
        },
      },
    });

    const totalClients = await feathers.service('clients').find({
      query: {
        deleted: { $ne: true },
        franchiseId: auth.getCurrentUser().franchiseId,
        $limit: 0,
      },
    });

    this.setState({
      totalClients: totalClients.total,
    });
  };

  async componentWillMount() {
    if (!auth.verifyLogin()) return false;

    await this.getClients();
  }

  componentDidUpdate(prevProps) {

    if (prevProps.Clients.searchData !== this.props.Clients.searchData) {
      const totalSearchData =
        this.props.Clients && this.props.Clients.searchData
          ? this.props.Clients.searchData.length
          : this.props.Clients.data.length;

      this.setState({
        totalClients: totalSearchData,
      });
    }
  }

  search(event) {
    let search = event.target.value;
    this.props.searchTable(search);
  }

  setTime = () => {
    this.exportClients();
    this.setState({ disabledExport: true });
    setTimeout(() => {
      this.setState({ disabledExport: false });
    }, 30000);
  };

  exportClients = () => {
    window.location =
      process.env.REACT_APP_URL_FEATHERS +
      '/export-clients?id=' +
      auth.getCurrentUser().franchiseId;
  };

  async onDelete(confirm = false) {
    if (confirm) {
      await this.props.update(this.state.id, { deleted: true });
      this.setState({ openConfirm: false });
      await this.getClients();
    } else {
      this.setState({ openConfirm: true });
    }
  }

  handleInputChange = async (event) => {
    let value = event.target.value;

    if (String(value).trim() === '') {
      this.setState({ formData: { searchClient: '' } });
      this.props.Clients.search = '';
      await this.getClients();
    }

    this.setState({
      formData: {
        searchClient: value,
      },
    });
  };

  searchClient = async () => {
    const { searchClient } = this.state.formData;
    const { history } = this.props;

    if (searchClient) {
      this.props.searchTable(searchClient);
    }
  };

  render() {
    const _this = this;
    const { history, Clients } = this.props;
    const { openConfirm } = this.state;
    return (
      <div className="main-content">
        {openConfirm && (
          <SweetAlert
            warning
            style={{ display: 'block', marginTop: '-100px' }}
            title="¿Estás Seguro?"
            onConfirm={() => this.onDelete(true)}
            onCancel={() => this.setState({ openConfirm: false })}
            confirmBtnBsStyle="info"
            cancelBtnBsStyle="danger"
            confirmBtnText="Si, borrar!"
            cancelBtnText="Cancelar"
            showCancel
          >
            No podrás deshacer está opción!
          </SweetAlert>
        )}
        <Grid fluid>
          <Row>
            <Col md={12}>
              <Card
                title={
                  <div>
                    <div>
                      <div className="pull-left header-table"></div>

                      <div className="pull-right header-table">
                        <Navbar.Form
                          pullLeft
                          className="navbar-search-form"
                        ></Navbar.Form>

                        <span
                          style={{
                            color: '#545b63',
                            fontSize: '16px',
                            marginRight: '20px',
                          }}
                        >
                          TOTAL DE CLIENTES:{''}
                          {''}
                          <strong>{this.state.totalClients}</strong>
                          {''}
                        </span>
                        <Button
                          bsStyle="primary"
                          wd
                          onClick={() => history.push('/admin/clients/create')}
                          style={{
                            marginBottom: '10px',
                          }}
                        >
                          Agregar Cliente
                        </Button>
                      </div>
                    </div>
                    <Grid>
                      <Row>
                        <Col md={5}>
                          <input
                            id="searchClient"
                            className="form-control"
                            placeholder="Buscar por nombre, telefono o correo"
                            type="text"
                            value={this.state.formData.searchClient}
                            onChange={this.handleInputChange}
                          />
                        </Col>

                        <Col md={3}>
                          <Button
                            style={{
                              backgroundColor: '#69a900',
                              border: '#69a900',
                              color: '#fff',
                              fontWeight: '500',
                            }}
                            onClick={() => this.searchClient()}
                          >
                            Buscar
                          </Button>
                        </Col>
                      </Row>
                    </Grid>
                    <div>
                      {!auth.can('sales') ? (
                        <Button
                          bsStyle="success"
                          wd
                          onClick={this.setTime}
                          disabled={this.state.disabledExport}
                          style={{
                            marginTop: '10px',
                            marginBottom: '10px',
                          }}
                        >
                          Exportar a Excel
                        </Button>
                      ) : null}
                    </div>
                  </div>
                }
                ctFullWidth
                content={
                  this.props.Clients.loading ? (
                    <Loading />
                  ) : (
                    <ReactTable
                      data={Clients.searchData || Clients.data}
                      page={Clients.table.page}
                      sorted={Clients.table.sorted}
                      filtered={Clients.table.filtered}
                      pageSize={Clients.table.pageSize}
                      onSortedChange={(change) =>
                        _this.props.changeTable('sorted', change)
                      }
                      onFilteredChange={(change) =>
                        _this.props.changeTable('filtered', change)
                      }
                      onPageChange={(change) =>
                        _this.props.changeTable('page', change)
                      }
                      onPageSizeChange={(change) =>
                        _this.props.changeTable('pageSize', change)
                      }
                      previousText={'Anterior'}
                      nextText={'Siguiente'}
                      loadingText={'Cargando...'}
                      noDataText={'No se encontraron registros'}
                      pageText={'Página'}
                      ofText={'de'}
                      rowsText={'filas'}
                      columns={[
                        {
                          Header: 'Nombre(s)',
                          accessor: 'firstName',
                          minWidth: 120,
                        },
                        {
                          Header: 'Apellidos',
                          accessor: 'lastName',
                          minWidth: 120,
                        },
                        {
                          Header: 'Teléfono',
                          accessor: 'phone',
                          minWidth: 120,
                        },
                        {
                          Header: 'Email',
                          accessor: 'email',
                          minWidth: 120,
                        },
                        {
                          Header: 'Ejecutivo',
                          accessor: 'assignedTo.firstName',
                          minWidth: 120,
                        },
                        {
                          Header: 'Fecha de creación',
                          accessor: 'date',
                          sortable: true,
                          filterable: false,
                          minWidth: 120,
                          Cell: (props) => (
                            <div>
                              <Badge
                                style={{
                                  fontSize: '14px',
                                  background: '#3a82cc',
                                }}
                              >
                                {props.original.createdOn &&
                                  moment(props.original.createdOn).format('ll')}
                              </Badge>
                            </div>
                          ),
                        },

                        {
                          Header: 'Acciones',
                          accessor: 'actions',
                          sortable: false,
                          filterable: false,
                          minWidth: 120,
                          Cell: (props) => (
                            <div className="actions-right">
                              {!auth.can('sales') ? (
                                <React.Fragment>
                                  <Button
                                    onClick={() =>
                                      history.push(
                                        '/admin/clients/' + props.original._id
                                      )
                                    }
                                    bsStyle="warning"
                                    simple
                                  >
                                    Editar
                                  </Button>
                                  <Button
                                    onClick={() =>
                                      this.setState({
                                        openConfirm: true,
                                        id: props.original._id,
                                      })
                                    }
                                    bsStyle="danger"
                                    simple
                                  >
                                    Borrar
                                  </Button>
                                </React.Fragment>
                              ) : (
                                <Button
                                  onClick={() =>
                                    history.push(
                                      '/admin/clients/' + props.original._id
                                    )
                                  }
                                  bsStyle="warning"
                                  simple
                                >
                                  Ver registro
                                </Button>
                              )}
                            </div>
                          ),
                        },
                      ]}
                      className="-striped -highlight"
                    />
                  )
                }
              />
            </Col>
          </Row>
        </Grid>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    Clients: state.Clients,
  };
};

const mapDispatchToProps = (dispatch) => {
  return bindActionCreators(ClientsActions, dispatch);
};

const ClientsConnect = connect(
  mapStateToProps,
  mapDispatchToProps
)(ClientsIndex);

export default ClientsConnect;



// WEBPACK FOOTER //
// ./src/views/Clients/ClientsIndex.jsx